// extracted by mini-css-extract-plugin
export default {"table":"paymentDetails_table__BazkJ","offcanvas":"paymentDetails_offcanvas__d9gv7","dashboardTable":"paymentDetails_dashboardTable__9z382"};